module.exports = "<a class=\"geo-menu__button\" style=\"display: block;\" [routerLink]=\"['./' + viagensRoute + '/' + deslocamentosRoute]\" routerLinkActive=\"active\" [routerLinkActiveOptions]=\"{ exact: true }\">\n    <svg>\n        <use xlink:href='../../assets/images/icons/icons.svg#icon-viagem' />\n    </svg>\n    <span>{{deslocamentosModule.plural}}</span>\n</a>";


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/viagens/shared/visitante-viagem-menu/visitante-viagem-menu.component.html
 ** module id = 966
 ** module chunks = 0
 **/